
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-participate",
      function () {
        return require("private-next-pages/how-to-participate/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-participate"])
      });
    }
  